import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Typography from '@segment/matcha/components/Typography';
export var Heading = /*#__PURE__*/_styled(Typography, true ? {
  target: "e1iovxur0"
} : {
  target: "e1iovxur0",
  label: "Heading"
})(true ? {
  name: "1mlhnwm",
  styles: "margin-top:0;margin-bottom:8px"
} : {
  name: "1mlhnwm",
  styles: "margin-top:0;margin-bottom:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvRGF0YVZpc3VhbGl6YXRpb24vSGVhZGluZy9IZWFkaW5nLnZpZXdzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUl5QyIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL0RhdGFWaXN1YWxpemF0aW9uL0hlYWRpbmcvSGVhZGluZy52aWV3cy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5pbXBvcnQgVHlwb2dyYXBoeSBmcm9tICdAc2VnbWVudC9tYXRjaGEvY29tcG9uZW50cy9UeXBvZ3JhcGh5J1xuXG5leHBvcnQgY29uc3QgSGVhZGluZyA9IHN0eWxlZChUeXBvZ3JhcGh5KWBcbiAgbWFyZ2luLXRvcDogMDtcbiAgbWFyZ2luLWJvdHRvbTogOHB4O1xuYFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});